(function(){

    const videoElements = document.querySelectorAll('[bw-video]')

    videoElements.forEach(video => {


        video.addEventListener('click',e => {
            e.preventDefault()
            const link = e.currentTarget;
            document.querySelector('#bw-custom-modal .modal-content').innerHTML = `
            <iframe src="https://www.youtube.com/embed/${link.getAttribute('href').replace('https://youtu.be/','').replace('https://www.youtube.com/watch?v=','')}"></iframe>
            `
            document.querySelector('#bw-custom-modal').style.display = "flex";
        })
    })


    let modal = document.createElement('div');
    modal.id = "bw-custom-modal"
    modal.innerHTML = `
    <div class="wrapper"></div>
    <div class="close-modal">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path d="M 38.982422 6.9707031 A 2.0002 2.0002 0 0 0 37.585938 7.5859375 L 24 21.171875 L 10.414062 7.5859375 A 2.0002 2.0002 0 0 0 8.9785156 6.9804688 A 2.0002 2.0002 0 0 0 7.5859375 10.414062 L 21.171875 24 L 7.5859375 37.585938 A 2.0002 2.0002 0 1 0 10.414062 40.414062 L 24 26.828125 L 37.585938 40.414062 A 2.0002 2.0002 0 1 0 40.414062 37.585938 L 26.828125 24 L 40.414062 10.414062 A 2.0002 2.0002 0 0 0 38.982422 6.9707031 z"/>
    </svg>
    </div>
    <div class="modal-content">
    </div>
    `
    modal.querySelectorAll('.close-modal,.wrapper').forEach(close => {
        close.addEventListener('click',e => {
            modal.querySelector('.modal-content').innerHTML = ''
            modal.style.display = "none"
        })
    })
    document.body.appendChild(modal)
})()